










































































































































































































































import Vue from 'vue'

export default Vue.extend({
    name: 'Maintenance',
    metaInfo: {
        title: 'Maintenance',
        meta : [
            {
                name: 'description',
                content : 'Proper maintenance is critical for ensuring adequate tie-down in a house. Learn more through several examples from damage investigations.'
            },
            {
                name: 'keywords',
                content : 'Maintenance, damage investigations, tie-down chain, retrofitting, cyclone, weather, storm, protection'
            }
        ]
    },

    data: () => ({

    }),
    computed: {

    },
})
